import React from "react";

// locales
import i18n from '../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// style
import "./Addmore.scss";

class Addmore extends React.Component {


	isButtonVisible() {
		const _current = this.props.current;
		const _total = this.props.total;
		let _template = null;
		// console.log(_current, _total);
		// console.log('_current >= _total: ' + (_current >= _total));
		if (_current < _total) {
			_template =
				<>
					{/* <pre>current: {this.props.current} - total: {this.props.total}</pre>*/}
					<p className="caption">{i18n.t('add.more.caption')}</p>
					<p className="text-center">
						<button className="btn btn-outline-secondary btn-outline-secondary-ing" onClick={this.props.onClick}>{i18n.t('add.more.btn')}</button>
					</p>
				</>
		} else {
			_template = null;
		}
		return _template;
	}

	// ____________________________________ render ____________________________________

	render() {
		return (
			<div className="container container-addmore">
				<div className="row justify-content-center">
					<div className="col-md-auto">
						{this.isButtonVisible()}
					</div>
				</div>
			</div>
		);
	}
}

export default withTranslation()(Addmore);